import React, { useEffect, useState } from "react";
import config from "../../config/config";
import { Link, useNavigate, useParams } from "react-router-dom";
import Web3 from "web3";

import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Fade } from "react-reveal";
import "../../component/nftdetail.css";
import {
  getDataForNftDetailsAction,
  updateCreditWalletStatusAction,
  UserProfile,
} from "../../Action/user.action";
import Cookies from "js-cookie";
import toast, { Toaster } from "react-hot-toast";
import { Vortex } from "react-loader-spinner";
import { commonService } from "../../services/common.services";
import { apiConstants } from "../../constant/api.constant";
import {
  getChainId,
  lidvaateNetwork,
  getWalletAddress,
  validateForm,
  prepareTransactionData,
  processTransaction,
  handleError,
  validateNetwork,
  realPayableAmountFromContract
} from "../BlockChain/blockchainNFTPurchase.helper";
import AddNetworkButton from "../../services/addNetwork.service";
import Swal from "sweetalert2";
const BuyNowNftBox = () => {
  const navigate = useNavigate()
  let { nftBoxValue } = useParams();
  const [userdata, setuserdata] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalLoad, setShowModalLoad] = useState(false);
  const [currentBNBBalance, setcurrentBNBBalance] = useState("0.000000");
  const [transactionError, settransactionError] = useState("");
  const [buyTransactionHash, setbuyTransactionHash] = useState("");
  const [connectWalletAddress, setConnectWalletAddress] = useState("");
  const [processData, setprocess] = useState("");
  const [MintingTimer, setMintingTimer] = useState("");
  const [rewardCategoriesDetails, setRewardCategoriesDetails] = useState([])
  const [nftBoxDetails, setNftBoxDetails] = useState([])
  const [stopPurchase, setStopPurchase] = useState(false);
  const [nftBoxPurchaseContractAddress, setNftBoxPurchaseContractAddress] = useState("");
  const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';

  const [isCheckedForCredit, setIsCheckedForCredit] = useState(false);
  const [mntData, setMntData] = useState([])

  const loginData = !Cookies.get("loginSuccessStepMrMint", {
    domain: "mrmint.io",
  })
    ? []
    : JSON.parse(
      Cookies.get("loginSuccessStepMrMint", { domain: "mrmint.io" })
    );

  useEffect(() => {

    if (nftBoxValue == 0) {
      navigate(`${config.baseUrl}nftbox`)
    } else {
      getDataForNftDetails()
      getKeyParams();
    }
  }, [])

  const updateCreditWalletStatus = async (isLock, amount = 0) => {
    let type = isLock ? 'lock' : 'release';
    const res = await updateCreditWalletStatusAction({ type, amount })
    if (res.success) {
      console.log(`Credit wallet status ${type} updated successfully`);
    } else {
      console.log(`Credit wallet status updat failed`);
    }
  }

  const getRealPayableAmountFromContract = async (resData) => {
    try {
      resData = resData || mntData

      const web3 = new Web3(config.rpcUrl);
      const _realPayableAmountFromContract = await realPayableAmountFromContract(web3, nftBoxValue)

      let creditPayable = (_realPayableAmountFromContract.updateAmountToken * config.creditUsePercent / 100) < parseFloat(resData.credit_balance)
        ? (_realPayableAmountFromContract.updateAmountToken * config.creditUsePercent / 100) : parseFloat(resData.credit_balance)


      setMntData({
        ...resData,
        amount_mnt: (_realPayableAmountFromContract.updateAmountToken || mntData.amount_mnt).toFixed(4) + " ANANT",
        real_amount_mnt: _realPayableAmountFromContract.updateAmountToken || mntData.amount_mnt,
        payableCreditAmount: creditPayable
      })

      return {
        amount_mnt: (_realPayableAmountFromContract.updateAmountToken || mntData.amount_mnt).toFixed(4) + " ANANT",
        real_amount_mnt: _realPayableAmountFromContract.updateAmountToken || mntData.amount_mnt,
        payableCreditAmount: creditPayable
      };

    } catch (error) {
      console.log("error in getRealPayableAmountFromContract", error);
      return {
        payableCreditAmount: 0
      }
    }
  }



  let getKeyParams = async () => {
    try {
      const response = await commonService.getWithToken(apiConstants.GET_KEY_PARAMS, {});
      if (response.success) {
        if (isProduction) {
          setNftBoxPurchaseContractAddress(response.data.mainnet);
        } else {
          setNftBoxPurchaseContractAddress(response.data.testnet);
        }
      } else {
        toast.error(response.msg);
      }
    } catch (error) {
      console.error("Error fetching country list:", error);
    }
  }

  useEffect(() => {
    setTimeout(() => {
      if (loginData.id) {
        getStepMintProfile();
        getBNBBalance();
      }
    }, 500);
  }, []);

  const getBNBBalance = async () => {
    if (window.ethereum) {
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      setConnectWalletAddress(accounts[0]);
      let web3 = new Web3(window.ethereum);
      let getBalace = (await web3.eth.getBalance(accounts[0])) / 10 ** 18;
      let currentBal = parseFloat(getBalace).toFixed(6);
      setcurrentBNBBalance(currentBal);
    }
  };


  const redirect = () => {
    setShowModalLoad(false);
    window.location.reload();
  };


  const getStepMintProfile = async () => {
    let res = await UserProfile();
    if (res.success) {
      setuserdata(res.data);
    } else {
      setuserdata([]);
    }
  };


  const handleBuyNFTBox = async () => {
    const isValid = validateForm(true, nftBoxValue, userdata, () =>
      toast.error("Please verify your wallet before purchase"), stopPurchase
    );
    if (!isValid) return;

    if (
      nftBoxPurchaseContractAddress &&
      nftBoxPurchaseContractAddress.toLowerCase() ===
      "0xE45FC6af0667D408A6ad6E3DFf4cd775a3CD8152".toLowerCase()
    ) {
      return toast.error("Please clear metamask cache and try again!");
    }

    if (stopPurchase) {
      toast.error("We hope you enjoyed the StepMint journey with Mr Mint Token. Stay tuned, as we'll be back with the ANANT coin.");
      return
    }
    if (!nftBoxValue) {
      toast.error('Please Nft Box Value')
      return
    }

    if (!isCheckedForCredit && mntData.payableCreditAmount > 0) {
      const result = await Swal.fire({
        html: `Are you sure you want to continue without using your available credit balance <b>${mntData.payableCreditAmount.toFixed(4)} ANANT</b> ? If you proceed, the full subscription amount <b>${mntData.real_amount_mnt.toFixed(4)} ANANT</b> will be charged to your Web3 wallet.`,
        showCancelButton: true,
        confirmButtonText: "Yes, proceed",
        cancelButtonText: "Cancel",
      });
      if (!result.isConfirmed) {
        return;
      }
    }

    setShowModal(true);
    setprocess("Your transaction is processing");

    try {
      const web3 = new Web3(window.ethereum);

      // ✅ Check chain
      const chainId = await getChainId(web3);
      const isNetworkValid = await validateNetwork(chainId, web3, setShowModal);
      if (!isNetworkValid) return;

      // ✅ Get wallet
      const from_address = await getWalletAddress();
      if (
        userdata?.bnb_address &&
        userdata.bnb_address.toLowerCase() !== from_address.toLowerCase()
      ) {
        toast.error("Please connect with your registered wallet");
        setShowModal(false);
        return;
      }


      let payableCreditAmount = 0;
      if (isCheckedForCredit) {
        const _getRealPayableAmountFromContract = await getRealPayableAmountFromContract()
        payableCreditAmount = _getRealPayableAmountFromContract.payableCreditAmount;
        if (payableCreditAmount > 0) {
          await updateCreditWalletStatus(true, payableCreditAmount);
        }
      }
      console.log("payableCreditAmount", payableCreditAmount);


      // ✅ Prepare transaction data
      const { contractWallet, updateAmountToken, balanceOf } =
        await prepareTransactionData(web3, from_address, nftBoxValue);

      if (!userdata?.id || (updateAmountToken - payableCreditAmount) > balanceOf) {
        setShowModal(false);
        toast.error(
          (updateAmountToken - payableCreditAmount) > balanceOf
            ? "Insufficient Balance"
            : "Please connect MetaMask"
        );
        return;
      }


      // ✅ Process transaction
      await processTransaction(
        web3,
        contractWallet,
        from_address,
        updateAmountToken,
        nftBoxValue,
        setbuyTransactionHash,
        setprocess,
        setMintingTimer,
        setShowModal,
        () => setShowModalLoad(true), // replace with success modal if needed
        payableCreditAmount
      );
    } catch (error) {
      handleError(error, setShowModal, settransactionError);
    } finally {
      setShowModal(false);
    }
  };


  const getDataForNftDetails = async () => {
    try {
      const res = await getDataForNftDetailsAction(nftBoxValue)
      if (res.success) {
        setRewardCategoriesDetails(res.data.reward_categories)
        setNftBoxDetails(res.data.box_purchase_details)
        setStopPurchase(res.data.stop_purchase)
      
        const _getRealPayableAmountFromContract = await getRealPayableAmountFromContract(res.data)
        res.data.amount_mnt = _getRealPayableAmountFromContract.amount_mnt
        res.data.real_amount_mnt = _getRealPayableAmountFromContract.real_amount_mnt
        res.data.payableCreditAmount = _getRealPayableAmountFromContract.payableCreditAmount
        console.log("res.data in nft box details", res.data);
        setMntData(res.data)
        await getRealPayableAmountFromContract(res.data)

      }
    } catch (error) {
      console.log(error);

    }
  }

  return (
    <>
      <Toaster />
      <section className="position-relative overflow-hidden nftdetail">
        <div className="leftshadow">
          <img src="assets/images/blueleft.png" />
        </div>
        <Container>
          <Row>
            <Col lg={12}>
              <div>
                <Fade right>
                  <h1 className="text-white">NFTs Box Details</h1>
                </Fade>
              </div>
            </Col>
            <Col lg={12}>
              <div className="card card-view border-0 p-4 position-relative overflow-hidden">
                <div>
                  <img
                    src="assets/images/logo-shap3.png"
                    className="botton-left"
                    style={{ zIndex: -1 }}
                  />
                </div>
                <Row className="gy-3 ">
                  <Col>
                    <div className="nftbox-card3 d-flex flex-column justify-content-center text-white px-4 pt-4 py-3">
                      <Row>
                        <Col>
                          <h3 style={{ fontWeight: 700 }}>NFT Box</h3>
                          <p className="nft-card-no mb-1">Total Subscription</p>

                        </Col>
                        <Col className="text-end mt-1">
                          <h5 style={{ fontWeight: 600 }}>{nftBoxValue}</h5>
                          <p className="nft-card-no mb-1">{mntData.amount_mnt}</p>
                        </Col>

                      </Row>
                      {/* <img src="assets/images/nftbackground.png" className="position-absolute" style={{opacity:0.4}} alt="" /> */}
                      <div className="w-100 d-flex flex-row justify-content-center gap-4">
                        <img src="assets/images/nftbox2.svg" alt="" />
                        <img
                          className="glow-img"
                          src="assets/images/nftbox1.svg"
                          alt=""
                        />
                        <img src="assets/images/nftbox2.svg" alt="" />
                      </div>
                    </div>
                  </Col>
                  <Col
                    style={{ border: "1px solid #ffffff50", borderRadius: 10 }}
                    className="d-flex flex-column align-items-center justify-content-center py-3 mx-2"
                  >
                    <Row className="gy-3">
                      <Col lg={12}>
                        <div className="nft-details-column d-flex justify-content-between p-2 highlight">
                          <p className="mb-0">Category</p>
                          <p className="mb-0">{nftBoxDetails.category_name}</p>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="nft-details-column d-flex justify-content-between p-2">
                          <p className="mb-0">Valid Till</p>
                          <p className="mb-0">{nftBoxDetails.validity}</p>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="nft-details-column d-flex justify-content-between p-2">
                          <p className="mb-0">Per Day Reward</p>
                          <p className="mb-0">{nftBoxDetails.reward_percent}</p>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="nft-details-column d-flex justify-content-between p-2">
                          <p className="mb-0">Expire On</p>
                          <p className="mb-0">{nftBoxDetails.expiry_date}</p>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <AddNetworkButton />
                      </Col>

                      <Col lg={12}>
                        <input
                          type="checkbox"
                          checked={isCheckedForCredit}
                          onChange={() => {
                            if (mntData.is_credit_locked) {
                              toast.error("Your credit balance is temporarily locked. Please refresh the page after a minute and try again.");
                              return
                            }
                            setIsCheckedForCredit(!isCheckedForCredit)
                          }}
                        />
                        <label className="sofia-sans" style={{ marginLeft: 5, color: 'yellow' }}>Use your credit balance to buy this NFT Box {(mntData.payableCreditAmount || 0).toFixed(4)} ANANT
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip
                                style={{
                                  maxWidth: "200px",
                                  whiteSpace: "normal",
                                  wordWrap: "break-word"
                                }}
                              >
                                Credit wallet balance is {mntData.credit_balance}. Only up to {config.creditUsePercent}% of the subscription amount can be used from your credit balance.
                              </Tooltip>
                            }
                          >
                            <span style={{ cursor: "pointer", color: "#17a2b8" }}> ℹ️</span>
                          </OverlayTrigger>
                        </label>
                      </Col>

                      <Col
                        lg={12}
                        className=" d-flex px-0 align-items-center justify-content-center"
                      >
                        <Row className="gy-2 px-0  w-100">
                          <Col lg={12} className="d-flex justify-content-center" onClick={handleBuyNFTBox}>
                            <button className="nftbox-submit w-100">
                              {" "}
                              Buy Now

                            </button>
                          </Col>

                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Col>


            {/* --------------------- */}
            <Modal
              show={showModal}
              className="walker_detail"
              centered
              size="l"
              backdrop="static"
            >
              <Modal.Body>
                <Row>
                  <Vortex
                    visible={showModal == true ? true : false}
                    height="80"
                    width="80"
                    ariaLabel="vortex-loading"
                    wrapperStyle={{}}
                    wrapperClass="vortex-wrapper"
                    colors={[
                      "#6610f2;",
                      "#6f42c1",
                      "blue",
                      "#300d39",
                      "#212529",
                      "purple",
                    ]}
                  />
                  <div className="" style={{ display: "grid" }}>
                    <p style={{ margin: "auto" }}>
                      Please wait.....
                      {MintingTimer && `${MintingTimer} seconds`}{" "}
                    </p>
                    <p style={{ margin: "auto" }}>{processData}</p>
                  </div>
                </Row>
              </Modal.Body>
            </Modal>
            {/* ----------------- */}

            {/* --------------------- */}
            <Modal
              show={showModalLoad}
              className="walker_detail"
              centered
              size="l"
              backdrop="static"
            >
              <Modal.Body>
                <Row>
                  <div className="" style={{ display: "grid" }}>
                    <p style={{ margin: "auto" }}>
                      Your transaction is in Progress
                    </p>
                    <p style={{ margin: "auto" }}>
                      It will take some time to reflect to your account
                    </p>
                    <p style={{ margin: "auto" }}>
                      Your can check your transaction by visiting{" "}
                      <a
                        href={`${config.bsc_url}/${buyTransactionHash}`}
                        target="_blank"
                      >
                        {buyTransactionHash.slice(0, 4) +
                          "..." +
                          buyTransactionHash.slice(-4)}
                      </a>

                    </p>
                  </div>
                </Row>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-center">
                <Button variant="secondary" onClick={redirect}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
            {/* ----------------- */}
          </Row>
        </Container>
      </section>
    </>
  );
};
export default BuyNowNftBox;
